import { COMPANY } from "@/data/content";

// Direkter WhatsApp-Link (wa.me). Es wird nichts geladen, bis der Link
// angeklickt wird; erst dann entsteht eine Verbindung zu WhatsApp.
export const whatsappHref = (text) =>
  COMPANY.whatsappRaw
    ? `https://wa.me/${COMPANY.whatsappRaw}${text ? `?text=${encodeURIComponent(text)}` : ""}`
    : null;

export const hasWhatsapp = () => Boolean(COMPANY.whatsappRaw);
